module.exports = ".cursor-pointer {\n    cursor: pointer;\n}\n\n.header-container {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    margin-bottom: 16px;\n}\n\n.header-container > * {\n    margin-top: 0;\n    margin-bottom: 0;\n}\n\n.page-header {\n    padding-bottom: 0;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/organization/components/communication/templates/components/templates.component.css
// module id = ./src/app/organization/components/communication/templates/components/templates.component.css
// module chunks = main